<template>
  <div>
    <!--
    <div>
        <div class="py-2 px-3">
          <div
            class="mb-n1"
          >
            <base-skeleton
              v-if="loading"
              class="p-0"
            >
              <div
                class="skeleton__item py-3"
                style="max-width: 350px"
              />
            </base-skeleton>
            <div
              v-else
              class="d-flex"
            >
              <base-text
                size="l"
              >
                {{ subject | striphtml }}
              </base-text>
              <div class="ml-2 badge align-self-center">
                {{ getBadge() }}
              </div>
            </div>
          </div>
          <hr>
          <base-skeleton
            v-if="loading"
            class="p-0 d-flex justify-content-start align-items-center"
          >
            <base-text
              size="m"
              light
            >
              Delivered:
            </base-text>
            <div
              class="skeleton__item ml-2 mr-3"
              style="max-width: 200px"
            />
            <base-text size="m">
              Sent to:
            </base-text>
            <div
              v-for="n in 3"
              :key="`recipient_skel_${n}`"
              class="skeleton__item ml-2"
              :style="`max-width: 100px; opacity: ${1/n}; margin-top: 0`"
            />
          </base-skeleton>
          <div v-else>
            <base-text
              inline
              size="m"
              light
              class=""
            >
              <span
                v-if="isAdminMode"
                class="mr-2"
              >By: {{ stats.sender.user.first_name }} {{ stats.sender.user.last_name }}</span>
              <span>
                Delivered:
              </span>
              <span>
                {{ stats.time_iso | nicedate("long") }}
              </span>
            </base-text>
            <base-text
              inline
              size="m"
              class="ml-3"
            >
              Sent to:
            </base-text>
            <span
              v-for="(group, index) in stats.segments.groups"
              :key="group.pk"
            >
              <base-text
                inline
                size="m"
                semibold
                underline
                class="clickable"
                @click.native="goToOutreachActivity(group.pk)"
              >
                {{ group.name }}
              </base-text>
              {{ (stats.segments.groups.length > 1 && index < stats.segments.groups.length
                -1)
                ? ','
                : ''
              }}
            </span>
            {{ stats.segments.customers > 0 && stats.segments.groups.length > 0 ? '+' : '' }}
            <base-text
              v-if="stats.segments.customers > 0 || isNaN(stats.segments.customers)"
              inline
              size="m"
              semibold
              underline
              class="clickable"
              @click.native="goToOutreachActivity(0)"
            >
              {{ getClients() }}
            </base-text>
          </div>
        </div>
      </div>
    -->

    <div class="row justify-content-between">
      <div class="col-6">
        <out-reach-email-performance
          :labels="campaignChartLabels"
          :chartdata="campaignChartData"
          :height="height*0.8"
          :loading="loading"
        />
      </div>
      <div class="col-6">
        <doughnut-chart
          :entries="devicesChartData"
          :loading="loading"
        />
      </div>
      <div
        v-if="loading"
        class="col-3 mt-3"
      >
        <base-skeleton class="h-100">
          <div />
        </base-skeleton>
      </div>
    </div>

    <!--
    <div class="row gray-border py-4 mt-4 mx-2 text-center">
        <div
          v-for="entry in emailStats.events"
          :key="`emailStat_${entry.name}`"
          :class="`col-3 ${eventStatIsClickable(entry.name) ? 'clickable' : ''}`"
          @click="onEventStatClicked(entry)"
        >
          {{ entry.name }}:
          <base-skeleton
            v-if="loading"
            style="background-color: transparent !important"
            class="d-flex justify-content-center"
          >
            <div
              class="skeleton__item py-2"
              style="max-width: 80px"
            />
          </base-skeleton>
          <base-text
            v-else
            size="l"
            class="text-center ml-2"
          >
            {{ entry.value }}
          </base-text>
        </div>
      </div>
      <div class="row m-2 p-2">
        <div
          v-for="entry in emailStats.totals"
          :key="`emailStatTotal_${entry.name}`"
          class="col-6 d-flex py-2 px-4 justify-content-between"
        >
          <span>{{ entry.name }}</span>
          <base-skeleton
            v-if="loading"
            class="p-0"
            style="background-color: transparent !important"
          >
            <div
              class="skeleton__item py-2"
              style="width: 80px"
            />
          </base-skeleton>
          <span v-else>{{ entry.value }}</span>
        </div>
      </div>
      -->
  </div>
</template>
<script>

export default {
  name: 'OutReachEmailPerformanceContainer',
  data() {
    return {
      height: 300,
    };
  },
  computed: {
    loading() {
      return this.$store.state.outreachs.statsLoading;
    },
    stats() {
      return this.$store.state.outreachs.stats;
    },
    subject() {
      return this.stats.edit ? this.stats.edit.subject : '';
    },
    campaignChartData() {
      return [{
        name: 'Open Rate',
        values: [this.stats.open_rate, this.stats.open_average_rate, this.stats.open_peer_rate],
      }, {
        name: 'Click Rate',
        values: [this.stats.click_rate, this.stats.click_average_rate, this.stats.click_peer_rate],
      }, {
        name: 'Unsubscribes',
        values: [this.stats.unsubscribe_rate, this.stats.unsubscribe_average_rate, this.stats.unsubscribe_peer_rate],
      }];
    },
    campaignChartLabels() {
      return [
        ['This campaign’s', 'performance'],
        ['Your average campaign', 'performance'],
        ['Your peer’s average', 'performance'],
      ];
    },
    devicesChartData() {
      if (!this.stats || !this.stats.device_rate) {
        return [{
          name: 'Desktop',
          value: 0,
        }, {
          name: 'Mobile',
          value: 0,
        }, {
          name: 'Tablet',
          value: 0,
        }];
      }
      return this.stats.device_rate;
    },
    emailStats() {
      return {
        events: [{
          name: 'Clients Opened',
          value: this.stats.opened_clients,
        },
        {
          name: 'Clients Clicked',
          value: this.stats.clicked_clients,
        },
        {
          name: 'Emails Bounced',
          value: this.stats.bounced_clients,
        },
        {
          name: 'Unsubscribed',
          value: this.stats.unsubscribed_clients,
        },
        ],
        totals: [{
          name: 'Total Opens',
          value: this.stats.opens,
        },
        {
          name: 'Successful Deliveries',
          value: this.stats.successful_count,
        },
        {
          name: 'Total Clicks',
          value: this.stats.clicks,
        }, {
          name: 'Total Spam Reports',
          value: this.stats.report_count,
        },
        ],
      };
    },
    outreachId() {
      return this.$route.params.id;
    },
  },
  methods: {
    getClients() {
      if (Number.isNaN(this.stats.segments.customers)) {
        return this.stats.segments.customers;
      }
      return `${this.stats.segments.customers} Client${this.stats.segments.customers === 1 ? '' : 's'}`;
    },
    getBadge() {
      const values = {
        email: 'Email',
        pdf: 'PDF',
        wechat: 'WeChat',
        html: 'Link',
      };
      return values[this.stats.display];
    },
    showEvents() {
      if (this.stats.recipient_count === 0) {
        return;
      }
      this.$router.push({
        name: 'ReportActivity',
        params: {
          outreach: this.outreachId,
        },
      });
    },
    onEventStatClicked({ name }) {
      const lname = name.toLowerCase();
      if (lname.includes('open')) {
        this.$router.push({ path: `/reports/outreach/${this.outreachId}/activity/open` });
      } else if (lname.includes('click')) {
        this.$router.push(`/reports/outreach/${this.outreachId}/activity/click`);
      } else if (lname.includes('bounce')) {
        this.$router.push(`/reports/outreach/${this.outreachId}/activity/bounce`);
      } else if (lname.includes('unsubscribe')) {
        this.$router.push(`/reports/outreach/${this.outreachId}/activity/unsubscribe`);
      } else {
        console.warn(`Cannot show details for ${name}`);
        this.$router.push(`/reports/outreach/${this.outreachId}/activity/all_recipients`);
      }
    },
    eventStatIsClickable(name) {
      return ['open', 'click', 'bounced', 'unsubscribed'].some((eventName) => name.toLowerCase().includes(eventName));
    },
    /**
      Redirects to outreach activity view.
        group: Number: Filters by group id
        group: 0: Only shows independent customers
        group: undefined: show all recipients
    */
    goToOutreachActivity(group = undefined) {
      this.$router.push({ path: `/reports/outreach/${this.outreachId}/activity/`, query: { group } });
    },
  },
};
</script>
<style scoped
  lang="scss">
.gray-border {
  border: solid 1px #33333344;
  border-radius: 6px;
}

.clickable {
  cursor: pointer;

  &:hover {
    ::v-deep .base-text {
      text-decoration: underline;
    }
  }
}

.badge {
  padding: 5px;
  background-color: #dddf96;
}
::v-deep .card-body {
  border: solid 1px #33333344;
  border-radius: 6px;
  overflow: hidden;
}
</style>
